export default function returnError(stage, signInType) {
    const verifyEmail = "verify your email address.";
    const verifyPhone = "verify your mobile phone number.";
    const errorMap = {
        EMAIL: verifyEmail,
        PHONE: verifyPhone,
        OTP: "sign you in.",
        VERIFY: {
            EMAIL: verifyEmail,
            PHONE: verifyPhone
        },
        RESET: {
            EMAIL: verifyEmail,
            PHONE: verifyPhone
        }
    }

    let error;

    if (stage === "VERIFY") {
        error = errorMap.VERIFY?.[signInType];
    }
    else if (stage === "RESET") {
        error = errorMap.RESET?.[signInType];
    }
    else {
        error = errorMap[stage];
    }

    if (!error) {
        return null;
    }

    return (
        <span>We're unable to {error}</span>
    );
}